/* Hot Hand Hero Banner - fade-in-up on scroll */
(function () {
  function initHotHandHero(section) {
    var animatedEls = section.querySelectorAll('[data-hh-animate]');
    if (!animatedEls.length) return;

    if (!('IntersectionObserver' in window)) {
      animatedEls.forEach(function (el) {
        el.classList.add('hh-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = el.getAttribute('data-hh-delay') || 0;
            el.style.setProperty('--hh-delay', delay + 'ms');
            el.classList.add('hh-in-view');
            observer.unobserve(el);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    animatedEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-type="hot-hand-hero-banner"]')
      .forEach(initHotHandHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support: re-init when block/section is selected or loaded
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type="hot-hand-hero-banner"]');
    if (section) initHotHandHero(section);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    if (el && el.classList && el.classList.contains('hh-animate')) {
      el.classList.add('hh-in-view');
    }
  });
})();
